class GalleryLightbox extends HTMLElement {
  constructor() {
    super();

    this.images = [];
    this.currentIndex = 0;
    this.openedBy = null;

    this.stage = this.querySelector('.gallery-lightbox__stage');
    this.stageImage = this.querySelector('.gallery-lightbox__image');
    this.counterCurrent = this.querySelector('.gallery-lightbox__counter-current');
    this.counterTotal = this.querySelector('.gallery-lightbox__counter-total');
    this.prevButton = this.querySelector('.gallery-lightbox__arrow--prev');
    this.nextButton = this.querySelector('.gallery-lightbox__arrow--next');
    this.closeButton = this.querySelector('.gallery-lightbox__close');

    this.prevButton.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.nextButton.addEventListener('click', () => this.show(this.currentIndex + 1));
    this.closeButton.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (event.target === this || event.target.classList.contains('gallery-lightbox__backdrop')) {
        this.close();
      }
    });

    this.addEventListener('keydown', (event) => {
      if (!this.hasAttribute('open')) return;
      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowLeft') this.show(this.currentIndex - 1);
      if (event.key === 'ArrowRight') this.show(this.currentIndex + 1);
    });

    this.setupSwipe();
    this.collectImages();
  }

  collectImages() {
    const triggers = Array.from(document.querySelectorAll('.rte--image-grid img[src]:not([src=""])'));
    this.images = triggers;
    this.counterTotal.textContent = triggers.length;

    triggers.forEach((img, index) => {
      img.classList.add('gallery-lightbox-trigger');
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');

      img.addEventListener('click', () => this.open(index, img));
      img.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.open(index, img);
        }
      });
    });
  }

  open(index, opener) {
    if (!this.images.length) return;
    this.openedBy = opener || document.activeElement;
    this.show(index);
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    trapFocus(this, this.closeButton);
  }

  close() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }

  show(index) {
    if (!this.images.length) return;
    this.currentIndex = (index + this.images.length) % this.images.length;
    const source = this.images[this.currentIndex];
    this.stageImage.src = source.currentSrc || source.src;
    this.stageImage.alt = source.alt || '';
    this.counterCurrent.textContent = this.currentIndex + 1;
  }

  setupSwipe() {
    let startX = 0;
    let startY = 0;
    let pointerId = null;
    const SWIPE_THRESHOLD = 50;

    this.stageImage.setAttribute('draggable', 'false');
    this.stageImage.addEventListener('dragstart', (event) => event.preventDefault());

    this.stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      this.stage.setPointerCapture(pointerId);
    });

    this.stage.addEventListener('pointerup', (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      pointerId = null;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (Math.abs(deltaX) > SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
        this.show(this.currentIndex + (deltaX < 0 ? 1 : -1));
      }
    });

    this.stage.addEventListener('pointercancel', () => {
      pointerId = null;
    });
  }
}

customElements.define('gallery-lightbox', GalleryLightbox);
